<div id="collections-graph-wrapper">
  <div id="chart-heading">
    <span class="collection-title-wrapper">
      <span id="chart-title">
        Net Collection Rate
      </span>
      <div id="static-note-container">
        Note: These are based on charge entry (Invoice creation) date</div>
    </span>
    <span class="right-header-wrapper">
      <app-variable-container
        [variables]="variables"
        [showVariableMenu]="showVariableMenu"
        [page]="page"
        [disabled]="activeVarianceToggle"
      ></app-variable-container>
      <app-variance-toggler [varianceToggleAction]="varianceToggle"></app-variance-toggler>
    </span>
  </div>
  <div [chart]="chartObject" id="collections-summary-graph"></div>
  <app-chart-legend [legends]="legends"
                    [hasBenchmarks]="hasBenchmarks"
                    [benchmarksToExclude]="benchmarksToExclude"
                    [defaultBenchmarkType]="defaultBenchmarkType">
  </app-chart-legend>
  <app-loader [class.loader-hidden]="!showProgressBar"></app-loader>
</div>
